export default async function loadWorklets(ctx: AudioContext) {
  await ctx.audioWorklet.addModule('audio/pcm-processor-mono.js'); // (and/or stereo)
  await ctx.audioWorklet.addModule('audio/pcm-processor-stereo.js'); // (and/or stereo)
}
